<!-- releaseExamInfo 发布考试信息 -->
<template>
  <div class="releaseExamInfo">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入考试科目" style="width: 200px;" @keyup.enter.native="tableLoad"
          @clear="query.query = ''; tableLoad();" clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button style="margin:0px 10px;" size="small" @click="tableLoad">查询</el-button>
        </Debounce>
        <el-select v-model="query.applicationYear" @change="tableLoad" filterable placeholder="请选择">
          <el-option label="全部年份" value=""></el-option>
          <el-option v-for="item in applicationFilterYearList" :key="item.value" :label="item.label + '年'"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select style="margin-left: 10px;width: 160px" v-model="query.hasLock" @change="tableLoad" filterable
          placeholder="请选择">
          <el-option label="全部科目状态" value=""></el-option>
          <el-option label="科目状态（正常）" :value="0"></el-option>
          <el-option label="科目状态（锁定）" :value="1"></el-option>
        </el-select>
        <!-- <el-date-picker
          v-model="query.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @clear="tableLoad"
          @change="tableLoad"
        >
            </el-date-picker> -->
      </el-col>
      <el-button type="primary" size="small" @click="operatInfo(1)">添加</el-button>
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
      :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中"
      :height="$store.getters.getTableHeight">
  
      <el-table-column prop="subjectName" label="考试科目" align="center"></el-table-column>
      <el-table-column prop="applicationYear" label="考试年份" width="200px" align="center"
        :formatter="formatApplicationYear">
      </el-table-column>
      <el-table-column prop="kspc" label="考试批次" align="center">
        <template slot-scope="scope">
          {{ scope.row.kspc === 1 ? "春季" : scope.row.kspc === 2 ? "夏季": scope.row.kspc === 3 ? "秋季" : scope.row.kspc === 4 ? "冬季":''}}
        </template>

      </el-table-column>
      <el-table-column label="考试形式" width="100px" align="center">
        <template slot-scope="scope">
          {{ scope.row.examinationForm === 1 ? "线下考试" : scope.row.examinationForm === 2 ? "线上考试" : "理论考试" }}
        </template>
      </el-table-column>
      <el-table-column prop="fbTime" label="报名开始时间" align="center">
      </el-table-column>
      <el-table-column prop="deadline" label="报名截止时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.deadline }}
        </template>
      </el-table-column>
      <el-table-column label="视频上传/理论考试/预计考试时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.startTime }}-
          {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120px" align="center">
        <template slot-scope="scope">
          <div class="tableSwitch">
            <el-switch v-model="scope.row.status" class="switch" @change="releaseSwitch(scope.row)" active-color="#409eff"
              active-text="已发布" :active-value="1" inactive-color="#c0c4cc" inactive-text="未发布" :inactive-value="0" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="tableContentUpdateBut" size="small"
            @click="operatInfo(2, scope.row)">修改</el-button>
          <span style="margin:0px 10px;">|</span>
          <Debounce>
            <el-button type="text" size="small" class="tableContentRemoveBut" :disabled="!scope.row.gridDelete"
              @click="operatInfo(0, scope.row)">删除</el-button>
          </Debounce>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"
      @pagination="tableLoad" />
    <el-dialog custom-class="dailogComponents" :title="visibleType == 1 ? '添加' : '修改'" :visible.sync="visible"
      :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="610px">
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p><span style="color:red;">*</span>考试年份:</p>
          </el-col>
          <el-col :offset="1">
            <el-select v-model="visibleObj.applicationYear" :disabled="visibleObj.status == 1" filterable
              placeholder="请选择">
              <el-option v-for="item in addApplicationYearList" :key="item.value" :label="item.label + '年'"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p><span style="color:red;">*</span>考试批次:</p>
          </el-col>
          <el-col :offset="1">
            <el-radio-group :disabled="visibleObj.status == 1||visibleType == 2" v-model="visibleObj.kspc">
              <el-radio :label="1">春季</el-radio>
              <el-radio :label="2">夏季</el-radio>
              <el-radio :label="3">秋季</el-radio>
              <el-radio :label="4">冬季</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p><span style="color:red;">*</span>考试科目:</p>
          </el-col>
          <el-col :offset="1">
            <el-select v-model="visibleObj.subjectId" :disabled="visibleObj.status == 1" filterable placeholder="请选择">
              <el-option label="请选择" value=""> </el-option>
              <el-option v-for="item in subjectList" :key="item.subjectId" :label="item.subjectName"
                :value="item.subjectId">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p><span style="color:red;">*</span>考试形式:</p>
          </el-col>
          <el-col :offset="1">
            <el-radio-group :disabled="visibleObj.status == 1" v-model="visibleObj.examinationForm">
              <el-radio :label="2">线上考试</el-radio>
              <el-radio :label="1">线下考试</el-radio>
              <el-radio :label="3">理论考试</el-radio>
            
            </el-radio-group>
          </el-col>
        </el-row>
 
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p><span style="color:red;">*</span>报名截止时间:</p>
          </el-col>
          <el-col :offset="1">
            <el-date-picker v-model="visibleObj.deadline" value-format="timestamp" type="datetime"
              prefix-icon="el-icon-date" default-time="23:59:59" placeholder="选择日期">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p>
              <span style="color:red;">*</span>{{
                visibleObj.examinationForm === 1 ? "预计考试时间" : visibleObj.examinationForm === 2 ? "视频上传时间" : "理论考试时间"
              }}:
            </p>
          </el-col>
          <el-col :offset="1">
            <el-date-picker v-model="visibleObj.dateTime" type="datetimerange" prefix-icon="el-icon-date"
              value-format="timestamp" range-separator="至" start-placeholder="开始日期"
              :default-time="['08:00:00', '23:59:59']" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="10">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <Debounce>
              <el-button size="medium" type="primary" @click="submit">确认</el-button>
            </Debounce>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableList: [],
      applicationFilterYearList: [],//年份过滤框
      addApplicationYearList: [],//添加年份下拉框
      tableIsLoad: true,
      roleList: [],
      subjectList: [],
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        deadline: "", //报名截止时间
        examinationForm: 2, //考试形式
        kspc: '', //考试批次(1:春季 2:夏季 3:秋季 4:冬季)
        subjectId: "",
        dateTime: [], //结束时间
        applicationYear: "",//考试年份
      },
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        applicationYear: "",//考试年份
        time: [],
        hasLock: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    };
  },
  async mounted() {
    await this.getApplicationFilterYearSelect();
    this.tableLoad();
    this.getSubject();
    this.getApplicationYearSelect();
  },
  methods: {
    //格式化年份
    formatApplicationYear: function (row, column) {
      return row.applicationYear + "年"
    },
    //获取考试年份过滤下拉
    async getApplicationFilterYearSelect() {
      await this.$axios.get("/examInformation/selectFilterData").then((rs) => {
        let appYears = rs.data.data;
        this.applicationFilterYearList = appYears;
        this.query.applicationYear = appYears[0].value;
      });
    },
    //获取添加年份下拉
    getApplicationYearSelect() {
      this.$axios.get("/examInformation/selectData").then((rs) => {
        let appYears = rs.data.data;
        this.addApplicationYearList = appYears;
      });
    },
    tableLoad() {
      this.$axios.post("/examInformation/list", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    getSubject() {
      this.$axios.get("/subject").then((res) => {
        this.subjectList = res.data.data.list;
      });
    },
    operatInfo(type, row) {
      // console.log(row.kspc,'row');
      this.visibleType = type;
      this.visibleObj = {
        deadline: "", //报名截止时间
        examinationForm: 2, //考试形式
        subjectId: "",
        kspc: '', //考试批次(1:春季 2:夏季 3:秋季 4:冬季)
        dateTime: [], //结束时间
        applicationYear: null,//考试年份
      };
      if (type === 0) {
        //删除
        this.$dailog({
          title: "删除",
          context: "是否删除所选内容?",
          callbackFun: () => {
            this.$axios.delete("/examInformation/" + row.id).then((res) => {
              this.$message({ type: "success", message: "删除成功!", duration: 1000 });
              this.tableLoad();
            });
          },
        });
      } else if (type === 1) {
        //初始值
        this.visibleObj.applicationYear = this.addApplicationYearList[2].value;
        //添加
        this.visible = true;
      } else {
        //修改
        this.visible = true;
        let deadline = new Date(row.deadline).getTime()
        let startTime = new Date(row.startTime).getTime()
        let endTime = new Date(row.endTime).getTime();
        console.log(deadline)
        this.visibleObj = {
          dateTime: [startTime, endTime],
          deadline: deadline,
          examinationForm: row.examinationForm,
          subjectId: row.subjectId,
          id: row.id,
          kspc: row.kspc, //考试批次(1:春季 2:夏季 3:秋季 4:冬季)
          status: row.status,
          applicationYear: [],
        };
        console.log( this.visibleObj,' this.visibleObj');
        //下拉匹配
        let nowYear = new Date().getFullYear();
        this.visibleObj.applicationYear = row.applicationYear.toString() + "年";
      }
    },
    submit() {
      let { deadline, subjectId, dateTime, id, status, applicationYear,kspc } = this.visibleObj;
      console.log(this.visibleObj);
      if (deadline === "" || subjectId === "" || dateTime.length === 0||kspc==='') {
        this.$message({ type: "warning", message: "必填项不能为空!", duration: 1000 });
        return;
      }
      let subType, subTath;
      this.visibleObj.startTime = dateTime[0];
      this.visibleObj.endTime = dateTime[1];
      this.visibleObj.deadline = deadline;
      this.visibleObj.applicationYear = applicationYear;
      if (this.visibleType === 1) {
        subType = "post";
        subTath = "/examInformation";
      } else {
        //解决修改时年份下拉框要求是当前年份和下一年，但是之前年份下拉框匹配不到的问题
        this.visibleObj.applicationYear = this.visibleObj.applicationYear.substr(0, 4);
        // 修改
        subType = "put";
        if (status == 1) {
          // 已经发布
          subTath = "/examInformation/update/time/" + id;
        } else {
          subTath = "/examInformation/" + id;
        }
      }
      this.$axios({
        method: subType,
        url: subTath,
        data: this.visibleObj,
      }).then((res) => {
        this.$message({ type: "success", message: "保存成功!", duration: 1000 });
        this.visible = false;
        this.tableLoad();
      });
    },
    releaseSwitch(row) {
      row.status = row.status == 0 ? 1 : 0;
      if (row.status === 1 && !row.gridCancel) {
        //发布
        this.$message({ type: "warning", message: "当前数据无法取消发布!", duration: 1000 });
        return;
      }
      let subPath =
        row.status === 0
          ? "/examInformation/publish/" + row.id
          : "/examInformation/unPublish/" + row.id;
      this.$dailog({
        title: row.status === 0 ? "发布" : "取消发布",
        context:
          row.status === 0 ? "确定发布考试信息?" : "确定取消发布考试信息?",
        callbackFun: () => {
          this.$axios.put(subPath).then((res) => {
            this.$message({ type: "success", message: "操作成功!", duration: 1000 });
            this.tableLoad();
          });
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.releaseExamInfo {
  .el-range-editor.el-input__inner {
    padding: 0px 10px;
  }

  .tableContentUpdateBut.is-disabled,
  .tableContentRemoveBut.is-disabled {
    color: #c0c4cc !important;
  }

  .el-date-editor--daterange {
    width: 300px;
  }
}
</style>
<style lang="scss">
.tableSwitch {

  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-right: 9px;
  }

  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 9px;
  }

  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 70px !important;
    margin: 0;
  }
}
</style>
